export default __webpack_public_path__ + "static/media/fastTrackAppointments_955x875.5cace94f.jpg";